import React, { Component } from "react";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
} from "antd";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../withRouter";

import CompanyAutocomplete from "./CompanyAutocomplete";

import dayjs from "dayjs";
import CompanyStore from "../store/CompanyStore";
import VehicleAuditSore from "../store/VehicleAuditStore";

class DiscountAdd extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = { loadingSpin: false, companyId: "", Id: -1, accidentType: 2 };

    this.vehicleAuditStore = new VehicleAuditSore(this);
    this.companyStore = new CompanyStore(this);
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.context.viewStateStore.setVehAuditStates({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.vehicleAuditStore.getVehicleData(
        this.props.getUserData().userCompanyId
      );

      await this.vehicleAuditStore.getDriverData(
        this.props.getUserData().userCompanyId
      );

      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
    }

    const Id = this.props.Id;

    if (Id) {
      await this.filldata(Id);
    }

    this.setState({ update: 1 });
  }

  async filldata(Id) {
    await this.setState({ loadingSpin: true });
    const getVehAuditData = await this.vehicleAuditStore.getVehAuditData({
      Id,
      companyId: this.props.companyId,
    });

    await this.vehicleAuditStore.getVehicleData(getVehAuditData.companyId);

    await this.vehicleAuditStore.getDriverData(getVehAuditData.companyId);

    await this.setState({
      companyId: getVehAuditData.companyId,
      Id: getVehAuditData.Id,
    });
    const singleData = await this.companyStore.getCompanyDataById(
      getVehAuditData.companyId
    );

    this.formRef.current.setFieldsValue({
      companyId: singleData,
      Id: getVehAuditData.Id,
      vehicleAuditScore: getVehAuditData.vehicleAuditScore,
      driverId: getVehAuditData.driverId,
      vehicleIds: getVehAuditData.vehicleId,
      Date: getVehAuditData.date ? dayjs(getVehAuditData.date) : null,
      outsidersn: getVehAuditData.outsidersn,
      comments: getVehAuditData.comments,
      accidentType: getVehAuditData.accidentType,
    });
    await this.setState({ loadingSpin: false });
  }

  onVehAuditDetailSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      Id: this.state.Id,
      companyId: this.state.companyId,
      Date: fieldsValue?.Date
        ? fieldsValue?.Date?.format("YYYY-MM-DD HH:mm:ss")
        : null,
      accidentType: this.state.accidentType,
    };
    //  "2024-07-02 16:27:00
    this.setState({ loading: true });
    const response = await this.vehicleAuditStore.addData(data);
    await this.props.response(response);

    this.setState({ loading: false });
  };

  async handleSearch() {
    await this.vehicleAuditStore.loadData({
      companyId: this.state.companyId,
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      page: this.state.currentPage,
    });
    await this.setState({ loadList: 1 });
  }

  async handleChange(comp) {
    await this.vehicleAuditStore.getVehicleData(comp.value);

    await this.vehicleAuditStore.getDriverData(comp.value);

    await this.setState({ companyId: comp.value });

    if (!this.props.Id) {
      this.context.viewStateStore.setVehAuditStates({
        companyId: comp.value,
      });
    }
    await this.setState({ companyId: comp.value });

    await this.handleSearch();
  }

  closeModal = () => {
    this.props.closeModal();
  };

  accidentType = (e) => {
    this.setState({ accidentType: e.target.value });
  };

  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Spin
            spinning={this.state.loadingSpin}
            wrapperClassName="spinClass"
            fullscreen
          >
            <Form
              ref={this.formRef}
              layout="vertical"
              name="nest-messages"
              onFinish={this.onVehAuditDetailSubmit}
              style={{ maxWidth: "100%", padding: 0 }}
              className="formClass"
              initialValues={{ Date: dayjs() }}
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="formColumnClass">
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                    <Form.Item
                      name="companyId"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                      className="uploadCompany"
                    >
                      <CompanyAutocomplete
                        onChange={(value) => this.handleChange(value)}
                        style={{ width: "100%" }}
                        value={this.state.companyId}
                      />
                    </Form.Item>
                  )}

                  <Form.Item
                    label={
                      <span>
                        {this.context.translate("_ASSET_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_ASSET_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                    name="vehicleIds"
                    className="uploadCompany"
                  >
                    <Select
                      options={this.vehicleAuditStore.vehicleArr}
                      fieldNames={{
                        value: "vehicleId",
                        label: "vehicleNo",
                      }}
                    ></Select>
                  </Form.Item>

                  <Form.Item
                    className="uploadCompany"
                    name="vehicleAuditScore"
                    label={this.context.translate("_VEHICLE_AUDIT_SCORE_")}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    className="uploadCompany"
                    name="accidentType"
                    label={this.context.translate("_ACCIDENT_TYPE_")}
                  >
                    <Radio.Group onChange={this.accidentType} defaultValue={2}>
                      <Radio value={1}>{this.context.translate("_MAJOR_ACCIDENT_")}</Radio>
                      <Radio value={2}>{this.context.translate("_MINOR_ACCIDENT_")}</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                <Col span={12} className="formColumnClass">
                  <Form.Item
                    className="uploadCompany"
                    name="comments"
                    label={
                      <span>
                        {this.context.translate("_ACCIDENT_REASON_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_ACCIDENT_REASON_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label={
                      <span>
                        {this.context.translate("_DRIVER_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_DRIVER_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                    name="driverId"
                    className="uploadCompany"
                  >
                    <Select
                      options={this.vehicleAuditStore.driverArr}
                      fieldNames={{
                        value: "driverId",
                        label: "driverName",
                      }}
                    ></Select>
                  </Form.Item>

                  <Form.Item
                    className="uploadCompany"
                    name="Date"
                    label={this.context.translate("_DATE_")}
                    rules={[{ type: Date }]}
                  >
                    <DatePicker
                      showTime
                      style={{ width: "100%", height: "40px" }}
                      format="DD-MM-YYYY hh:mmA"
                      onChange={(date) => {
                        if (date) {
                          this.formRef.current.setFieldsValue({ date: date });
                        }
                      }}
                      disabledDate={(current) => {
                        return current && current > dayjs();
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="outsidersn"
                    label=" "
                    valuePropName="checked"
                    className="uploadCompany"
                  >
                    <Checkbox>
                      {this.context.translate("_OUTSIDE_PARTY_")}
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={() => {
                    this.closeModal();
                  }}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button
                  htmlType="submit"
                  className="formsSaveButton"
                  loading={this.state.loading}
                >
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                </Button>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    );
  }
}
DiscountAdd.contextType = StoreContext;
export default observer(withRouter(DiscountAdd));
